// Doubles helper: resolves 'p1+p2' to 'Anand / Pramod' or 'p1' to 'Anand'
export function resolveTeam(id, players) {
  if (!id) return { name: 'TBD', ids: [] };
  if (String(id).includes('+')) {
    const ids = String(id).split('+');
    const names = ids.map(pid => {
      const player = players.find(p => String(p.id || p._id) === String(pid));
      return player?.name || 'TBD';
    });
    return { name: names.join(' / '), ids };
  }
  const p = players.find(p => String(p.id || p._id) === String(id));
  return { name: p?.name || 'TBD', ids: [id] };
}

// Check if a player is part of a team ID
export function isPlayerInTeam(playerId, teamId) {
  if (!teamId || !playerId) return false;
  if (teamId.includes('+')) return teamId.split('+').includes(playerId);
  return teamId === playerId;
}

// Check if a player is registered in a tournament (works for both singles and doubles)
export function isPlayerRegistered(playerId, registeredPlayers) {
  return registeredPlayers.some(rp => isPlayerInTeam(playerId, rp));
}
